export default __webpack_public_path__ + "static/landmark-453db3f113b8f5ed6deeebff03c44798.svg";